import RecurringToggle from './RecurringToggle';

export default RecurringToggle;



// WEBPACK FOOTER //
// ./src/components/shared/RecurringToggle/index.js